import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { Core } from "@faire/design-tokens";
import { SearchableSelect } from "@faire/help-center-utils/components/SearchableSelect/SearchableSelect";
import { getBrandBusinessName, getBrandToken } from "@faire/help-center-utils/serialized-data/getBrand";
import { getRetailerBusinessName, getRetailerToken } from "@faire/help-center-utils/serialized-data/getRetailer";
import { trackHelpCenterActionModalLogoutClick } from "@faire/web-api/events/helpCenter/click/actionModalLogout";
import { trackHelpCenterActionModalSubmit } from "@faire/web-api/events/helpCenter/submit/actionModal";
import home from "@faire/web-api/routes/root";
import brands from "@faire/web-api/routes/support/brands";
import retailers from "@faire/web-api/routes/support/retailers";
import { useStrictLocalization } from "@faire/web/common/localization";
import { Button } from "@faire/web/slate/Button";
import { Column, Row } from "@faire/web/slate/Layout";
import { Modal } from "@faire/web/slate/Modal";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { useState } from "@faire/web/ui/hooks/useState";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React, { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useActionTypes } from "../hooks/useActionTypes";
import { useBrandOrders } from "../hooks/useBrandOrders";
import { useModalContent } from "../hooks/useModalContent";
import { useShowMessage } from "../hooks/useShowMessage";
import { ButtonText } from "./ButtonText";
import { DropdownOption } from "./DropdownOption";
import { MessageInfo } from "./MessageInfo";
import { ActionModalContent, OptionName } from "./styles";
export var ActionModal = function ActionModal() {
  var _getRetailerBusinessN;
  var _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    modalContent = _useState2[0],
    setModalContent = _useState2[1];
  var title = modalContent === null || modalContent === void 0 ? void 0 : modalContent.title;
  var description = modalContent === null || modalContent === void 0 ? void 0 : modalContent.description;
  var _useState3 = useState(undefined),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedOption = _useState4[0],
    setSelectedOption = _useState4[1];
  var location = useLocation();
  var history = useHistory();
  var businessName = (_getRetailerBusinessN = getRetailerBusinessName()) !== null && _getRetailerBusinessN !== void 0 ? _getRetailerBusinessN : getBrandBusinessName();
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var _useActionTypes = useActionTypes(),
    actionType = _useActionTypes.actionType,
    clearActionType = _useActionTypes.clearActionType;
  var _useBrandOrders = useBrandOrders(),
    isUpdateCommissionModal = _useBrandOrders.isUpdateCommissionModal,
    dropdownOptions = _useBrandOrders.dropdownOptions;
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isModalOpen = _useState6[0],
    setIsModalOpen = _useState6[1];
  var modalContentByActionId = useModalContent();
  var _useShowMessage = useShowMessage(dropdownOptions, selectedOption),
    showEmptyState = _useShowMessage.showEmptyState,
    showNotShippedMessage = _useShowMessage.showNotShippedMessage,
    showBeingFulfilledMessage = _useShowMessage.showBeingFulfilledMessage,
    showNeedExtensionMessage = _useShowMessage.showNeedExtensionMessage,
    redirectLink = _useShowMessage.redirectLink;
  var canSubmit = !!selectedOption && !showNotShippedMessage && !showBeingFulfilledMessage && !showNeedExtensionMessage || showEmptyState;
  useEffect(function () {
    if (actionType) {
      var openModal = function openModal() {
        if (!modalContent && actionType) {
          var _modalContent = modalContentByActionId[actionType.id];
          setIsModalOpen(true);
          setModalContent(_modalContent);
        }
      };
      openModal();
    }
  }, [actionType, modalContent, modalContentByActionId, strictLocalize]);
  var isLandingPage = (location === null || location === void 0 ? void 0 : location.pathname) === brands() || (location === null || location === void 0 ? void 0 : location.pathname) === retailers();
  var handleSubmit = function handleSubmit() {
    if (!showEmptyState) {
      var _actionType$label;
      trackHelpCenterActionModalSubmit((_actionType$label = actionType === null || actionType === void 0 ? void 0 : actionType.label) !== null && _actionType$label !== void 0 ? _actionType$label : "");
    }
    history.push(redirectLink);
    if (isLandingPage) {
      closeModal();
    }
  };
  var logout = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _getRetailerToken, _getBrandToken;
      var retailerToken, brandToken;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            retailerToken = (_getRetailerToken = getRetailerToken()) !== null && _getRetailerToken !== void 0 ? _getRetailerToken : "";
            brandToken = (_getBrandToken = getBrandToken()) !== null && _getBrandToken !== void 0 ? _getBrandToken : "";
            trackHelpCenterActionModalLogoutClick(retailerToken, brandToken);
            _context.next = 5;
            return logout();
          case 5:
            history.push(home());
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function logout() {
      return _ref.apply(this, arguments);
    };
  }();
  var closeModal = function closeModal() {
    if (isModalOpen) {
      clearActionType();
      setIsModalOpen(false);
      setModalContent(undefined);
      setSelectedOption(undefined);
    }
  };
  return /*#__PURE__*/React.createElement(Modal, {
    contentStyle: {
      overflow: "visible"
    },
    padding: "0",
    isOpen: isModalOpen,
    onClose: closeModal,
    height: "auto"
  }, /*#__PURE__*/React.createElement(ActionModalContent, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "pageHeaderSerifRegular",
    align: "center"
  }, title), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, {
    align: "center"
  }, description), /*#__PURE__*/React.createElement(Spacer, {
    height: "3x"
  }), /*#__PURE__*/React.createElement(SearchableSelect, {
    onSelect: setSelectedOption,
    options: dropdownOptions,
    renderOption: function renderOption(optionProps) {
      return /*#__PURE__*/React.createElement(DropdownOption, _objectSpread(_objectSpread({}, optionProps), {}, {
        selected: optionProps.option.value === (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value)
      }));
    },
    placeholder: isUpdateCommissionModal ? strictLocalize({
      id: "+7famB",
      defaultMessage: [{
        "type": 0,
        "value": "Retailer selecteren"
      }]
    }) : strictLocalize({
      id: "IBug49",
      defaultMessage: [{
        "type": 0,
        "value": "Bestelling selecteren"
      }]
    }),
    searchKeys: ["name", "customerBrandOrderToken"]
  }, selectedOption !== null && selectedOption !== void 0 && selectedOption.name ? ( /*#__PURE__*/React.createElement(Row, {
    align: "center"
  }, selectedOption !== null && selectedOption !== void 0 && selectedOption.date ? ( /*#__PURE__*/React.createElement(Column, {
    flex: 1
  }, /*#__PURE__*/React.createElement(Typography, null, selectedOption.date))) : null, /*#__PURE__*/React.createElement(OptionName, null, selectedOption.name), selectedOption !== null && selectedOption !== void 0 && selectedOption.customerBrandOrderToken ? ( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spacer, {
    size: 12
  }), /*#__PURE__*/React.createElement(Column, {
    flex: 1
  }, /*#__PURE__*/React.createElement(Row, {
    align: "center"
  }, /*#__PURE__*/React.createElement(Typography, {
    color: Core.text.subdued
  }, selectedOption.customerBrandOrderToken), /*#__PURE__*/React.createElement(Spacer, {
    size: 26
  }))))) : null)) : null), /*#__PURE__*/React.createElement(MessageInfo, {
    selectedOption: selectedOption,
    dropdownOptions: dropdownOptions
  }), /*#__PURE__*/React.createElement(Spacer, {
    height: "5x"
  }), /*#__PURE__*/React.createElement(Button, {
    variant: showEmptyState ? "secondary" : "primary",
    disabled: !canSubmit,
    onClick: handleSubmit
  }, /*#__PURE__*/React.createElement(ButtonText, {
    selectedOption: selectedOption,
    dropdownOptions: dropdownOptions,
    modalContent: modalContent
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "2x"
  }), /*#__PURE__*/React.createElement(Row, {
    justify: "center",
    align: "baseline"
  }, businessName ? ( /*#__PURE__*/React.createElement(Typography, {
    color: Core.text.subdued
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "YVoUk0",
    defaultMessage: [{
      "type": 0,
      "value": "Aangemeld als "
    }, {
      "children": [{
        "type": 1,
        "value": "businessCompanyName"
      }],
      "type": 8,
      "value": "b"
    }],
    values: {
      businessCompanyName: businessName
    }
  }))) : null, /*#__PURE__*/React.createElement(Spacer, {
    width: "1x"
  }), /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    onClick: logout,
    style: {
      minWidth: "60px"
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    color: Core.text.subdued
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "rvenkW",
    defaultMessage: [{
      "type": 0,
      "value": "Afmelden"
    }]
  }))))));
};